var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKnowledgedriven(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 333.05 384",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Knowledge driven") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    className: "cls-1",
    d: "M219.86,358V336h-30v22Zm303,.06V336h-30v22.12ZM495.12,253.71,468.79,269,480,288.42l26.32-15.24C502.57,266.64,499,260.42,495.12,253.71ZM298,223.07l-15.2-26.39L263.31,208l15.22,26.36Zm116.85,0c6.68,3.86,13,7.49,19.45,11.23,5.19-9,10.13-17.6,15.18-26.39L430,196.69ZM217.64,253.69l-11.23,19.48,26.34,15.21L244,268.93Z",
    transform: "translate(-189.85 -180)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M351.88,564c-6.05-2.46-12.67-4-18-7.55C322.36,549,316.67,537.7,316,524c0-.86-.1-1.73-.19-3.07H293V516c0-17.62-.26-35.25.08-52.86.27-13.89-4.57-25.13-14.55-34.72-18-17.31-29.37-38.46-33-63.23-6.3-43.08,7.26-79.27,41-106.55,66.73-54,166.57-16.7,181.78,67.78,7.1,39.38-4.42,73.63-32.61,102-6.69,6.73-12.1,14-13.74,23.47a60.36,60.36,0,0,0-.74,10.06c-.07,18,0,36,0,54v4.79h-22.5c-.5,3.9-.58,7.54-1.48,11-4.53,17.32-15.54,28-33.16,31.62a10.94,10.94,0,0,0-1.69.66Zm-6-115.94c0-12.69.05-24.93-.09-37.17a4.61,4.61,0,0,0-2-3.09c-6.22-4.17-12.24-8.78-18.9-12.07-7.87-3.87-10.83-9.19-9.79-17.94.86-7.23.18-14.64.18-22h22.46c0,6.39-.12,12.5.09,18.61a5.53,5.53,0,0,0,2,3.86c5,3.5,10.15,6.8,15.39,9.94a4.51,4.51,0,0,0,3.88,0c5-3,9.84-6.37,14.85-9.4a4.78,4.78,0,0,0,2.57-4.83c-.15-6.06-.06-12.13-.06-18.21h22.46c0,10.28-.08,20.37.07,30.46,0,2.48-.88,3.79-2.9,5.05-8.55,5.37-17,10.83-25.43,16.46a5.77,5.77,0,0,0-2.21,4.08c-.18,11.25-.11,22.49-.09,33.74a26.09,26.09,0,0,0,.25,2.6h31.16c2.77-16.26,12.79-27.83,23.62-39.45,21.26-22.79,28.86-50.26,22.3-80.75-10.28-47.83-54.23-77.69-102.75-70.72-50.45,7.25-85.85,58.9-74.57,108.75,4.1,18.15,12.62,33.82,26.07,46.69,7.69,7.36,13.77,15.77,17.35,25.86,1.11,3.15,2,6.39,2.92,9.58Zm-30.16,22.88v27.11h82.69V470.94Zm22.73,50.11c-.31,7.44,2.32,13.29,8.41,17.29,6.38,4.19,13.15,4.39,19.72.47s9.41-9.93,9.18-17.76Z",
    transform: "translate(-189.85 -180)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M367.6,180v30.14H345.15V180Z",
    transform: "translate(-189.85 -180)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M219.86,358h-30V336h30Z",
    transform: "translate(-189.85 -180)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M522.91,358.08h-30V336h30Z",
    transform: "translate(-189.85 -180)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M495.12,253.71c3.87,6.71,7.45,12.93,11.21,19.47L480,288.42,468.79,269Z",
    transform: "translate(-189.85 -180)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M298,223.07l-19.42,11.25L263.31,208l19.44-11.28Z",
    transform: "translate(-189.85 -180)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M414.8,223.07,430,196.69l19.43,11.22c-5.05,8.79-10,17.38-15.18,26.39C427.79,230.56,421.48,226.93,414.8,223.07Z",
    transform: "translate(-189.85 -180)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M217.64,253.69,244,268.93l-11.21,19.45-26.34-15.21Z",
    transform: "translate(-189.85 -180)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKnowledgedriven);
export default __webpack_public_path__ + "static/media/Knowledge driven.36a7ac867b3d26a22a0869779046e277.svg";
export { ForwardRef as ReactComponent };